const WISHLIST_KEY = 'wishlist';

const Wishlist = {
  get() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch {
      return [];
    }
  },
  save(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
  },
  has(id) {
    return this.get().some(item => item.id === id);
  },
  toggle(product) {
    let items = this.get();
    if (this.has(product.id)) {
      items = items.filter(item => item.id !== product.id);
    } else {
      items.push(product);
    }
    this.save(items);
    return this.has(product.id);
  },
  remove(id) {
    this.save(this.get().filter(item => item.id !== id));
  },
  count() {
    return this.get().length;
  }
};

// --- Toggle buttons on cards + product pages ---
function initWishlistButtons() {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    if (Wishlist.has(btn.dataset.wishlistId)) btn.classList.add('is-active');

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const product = {
          id: btn.dataset.wishlistId,
          handle: btn.dataset.wishlistHandle,
          title: btn.dataset.wishlistTitle,
          price: btn.dataset.wishlistPrice,
          image: btn.dataset.wishlistImage,
          url: btn.dataset.wishlistUrl,
        };
        btn.classList.toggle('is-active', Wishlist.toggle(product));
      });
  });
}

// --- Header count badge ---
function updateWishlistCount() {
  const badge = document.querySelector('[data-wishlist-count]');
  if (!badge) return;
  const count = Wishlist.count();
  badge.textContent = count;
  badge.hidden = count === 0;
}


// --- Wishlist page rendering ---
function renderWishlistPage() {
  const grid = document.querySelector('[data-wishlist-grid]');
  if (!grid) return;
  const empty = document.querySelector('[data-wishlist-empty]');
  const items = Wishlist.get();

  if (!items.length) {
    grid.innerHTML = '';
    if (empty) empty.hidden = false;
    return;
  }
  if (empty) empty.hidden = true;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  grid.innerHTML = items.map(item => `
    <article class="product-item grid-item-33">
      <div class="product-item__wrapper">

        <div class="product-item__image-wrapper">
          <div class="height-inherit">
            <a href="${esc(item.url)}">
              <img src="${esc(item.image)}" class="product-item-image"
                   alt="${esc(item.title)}" loading="lazy">
            </a>
          </div>
        </div>

        ${item.vendor ? `
        <div class="product-type-vendor">
          <span>${esc(item.vendor)}</span>
        </div>` : ''}

        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div>
              <h3 class="product--item-title">
                <a href="${esc(item.url)}">${esc(item.title)}</a>
              </h3>
              <div class="product-item-price">
                <span class="money">${esc(item.price)}</span>
              </div>  
          </div>
          <button type="button" class="wishlist-btn is-active" style="border:none;outline:none;"
                  data-wishlist-remove="${esc(item.id)}" aria-label="Remove from wishlist">
          <svg class="wishlist-btn__icon" width="22" height="22" viewBox="0 0 24 24"
              fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 20.5C12 20.5 3.5 15 3.5 8.9C3.5 6.4 5.4 4.5 7.8 4.5C9.3 4.5 10.7 5.3 12 6.8C13.3 5.3 14.7 4.5 16.2 4.5C18.6 4.5 20.5 6.4 20.5 8.9C20.5 15 12 20.5 12 20.5Z"
                  fill="#000" stroke="#000" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        </div>
      </div>
    </article>
  `).join('');

  grid.querySelectorAll('[data-wishlist-remove]').forEach(btn => {
    btn.addEventListener('click', () => {
      Wishlist.remove(btn.dataset.wishlistRemove);
      renderWishlistPage();
      updateWishlistCount();
    });
  });
}


document.addEventListener('wishlist:updated', updateWishlistCount);
document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();
  updateWishlistCount();
  renderWishlistPage();
});